<div class="main-content-custom">
  <div class="container-fluid">
        <mat-divider></mat-divider>
        <div class="row" id="root">
              <div class="col-sm-12 col-md-8 col-lg-8 mr-auto ml-auto">
                    <div class="card-group">
                          <!-- content-panel-proyectos -->
                          <div class="card card-body-background " id="panel1">
                                <div class="card-header text-center  panel-header-kanban text-white">
                                        <label class="panel-kanban-title"> <h6>  Configuraciones primarias </h6>  </label>
                                </div>
                                <div class="card-body  panel-kanban-md panel-kanban-scroll">
                                      <div class="alert alert-info" role="status" *ngIf="isLoadingPrimary">
                                            Cargando configuraciones primarias...
                                      </div>
                                      <div class="alert alert-danger alert-dismissible" data-auto-dismiss="2000" role="alert" *ngIf="hasLoadedPrimary && listaConfigPrim.length === 0">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <strong>¡Lo sentimos,</strong> no existen configuraciones primarias!
                                      </div>

                                      <div class="card-kanban" *ngFor="let item of listaConfigPrim "  (click)="onSelect(item.nombre)" (keydown.enter)="onSelect(item.nombre)"   matTooltip="Ver Configuraciones Secundarias">
                                            <div class="card-kanban-header-dafault">
                                                  <strong> {{item.nombre}}</strong>
                                            </div>
                                            <div class="card-kanban-body" id="caeK">
                                                      <div class="col-auto mr-auto">
                                                            <span>
                                                                  <i class="fa fa fa-user-circle-o fa-lg text-primary"></i>
                                                                  <strong> Sitio:</strong> {{item.sitio}}
                                                            </span>
                                                      </div>
                                          </div>
                                      </div>
                                </div>
                          </div>
                          <!-- END content-panel-proyectos -->
                          <div class="card card-body-background" id="panel2">
                                <div class="card-header text-center panel-header-kanban-primary text-white">
                                      <label class="panel-kanban-title"> <h6> Configuraciones secundarias </h6> </label>
                                </div>
                                <div class="card-body  panel-kanban-md panel-kanban-scroll">

                                    <div class="alert alert-info" role="status" *ngIf="isLoadingSecondary">
                                          Cargando configuraciones secundarias...
                                    </div>
                                    <button mat-raised-button *ngIf="hasLoadedSecondary && listaConfigSec.length === 0" class="btn btn-primary btn-round" matTooltip="Crear Configuracion Secundaria" [disabled]="isLoadingSecondary" (click)="openDialogUpdate(confSec.conf_fol_pr)">
                                          <i class="material-icons">add_circle_outline</i> Crear Config. Secundaria
                                          </button>
                                      <div class="alert alert-danger alert-dismissible" data-auto-dismiss="2000" role="alert" *ngIf="hasLoadedSecondary && listaConfigSec.length === 0">
                                         
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                                                        aria-hidden="true">&times;</span></button>
                                            <strong>¡Lo sentimos,</strong> no encontramos configuraciones secundarias
                                            al proyecto!
                                      </div>
                                      <div class="col-sm-8 col-md-6 col-lg-6 " *ngIf="hasLoadedSecondary && listaConfigSec.length > 0">
                                   
                                          <button mat-raised-button class="btn btn-primary btn-round" matTooltip="Crear Configuracion Secundaria" [disabled]="isLoadingSecondary" (click)="openDialogUpdate(confSec.conf_fol_pr)">
                                                <i class="material-icons">add_circle_outline</i> Crear Config. Secundaria
                                                </button>
                                    </div>
                                      <div class="card-kanban" *ngFor="let item of listaConfigSec">
                                            <div class="card-kanban-header-grey">
                                                id: <strong> {{item.conf_fol_se + 1}} </strong>  <strong> {{item.conf_fol_se_dsc}}</strong>
                                            </div>
                                            <div class="card-kanban-footer">
                                                  <div class="row justify-content-end">
                                                        <div class="col-sm-4 col-md-4 col-lg-4">
                                                             <button mat-raised-button class="btn btn-success btn-round" matTooltip="Modificar configuracion secundaria" [disabled]="isDeleting" (click)="openDialogUpdate(item)">
                                                                  <i class="material-icons" >add_circle_outline</i> Modificar
                                                            </button>
                                                        </div>
                                                        <div class="col-sm-4 col-md-4 col-lg-4">

                                                            <button mat-raised-button class="btn btn-primary btn-round" matTooltip="Eliminar" [disabled]="isDeleting" (click)="eliminar(item)">
                                                                  <i class="material-icons" >delete</i> Eliminar
                                                            </button>
                                                        </div>
                                                  </div>
                                            </div>
                                      </div>
                                </div>
                          </div>
                          <!-- END content-panel-etapas -->
                    </div>
              </div>
        </div>
  </div>
</div>
